import React, { Component } from "react";
import Moment from "react-moment";
import { Table } from "react-bootstrap";
import { Link } from 'react-router-dom'
import JSONDebugger from '../utils/JSONDebugger'

export default class HistoryPanel extends Component {
  state = { order: true }
  render() {
    const { history } = this.props

    return (
      <div>
      <Table bordered condensed hover style={{fontSize: 13}}>
        <thead className='dark' id='history-panel'>
          <tr>
            <th><a href='#history-panel' onClick={() => this.setState({order: !this.state.order}) }>At</a></th>
            <th>User</th>
            <th>Action</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        {history.lines && history.lines.sort((a, b) => {
          if (this.state.order) return a.at > b.at ? 1 : -1
          return b.at > a.at ? 1 : -1
        }).map((hi, index) => (

          <tr key={index}>
            <td style={{width:170}}><Moment format="MMM Do YYYY hh:mma">{hi.at}</Moment></td>
            <td style={{width:170}}>{hi.user_name}</td>
            <td>
              {hi.data.type === 'lm_error' ? "LM Error" : hi.data.description}
            </td>
            <td >
              {hi.data.type === 'lm_error' && <JSONDebugger json={hi.data} />}
              {false && hi.data.seminar_registration_id && <div><Link to={`/m1/seminar_registrations/${hi.data.seminar_registration_id}`}>Seminar Registration</Link></div>}
              {false && hi.data.trial_coaching_session_id && <div><Link to={`/m1/tcs/${hi.data.trial_coaching_session_id}`}>Trial Coaching Session</Link></div>}

              {hi.data.from && <div>Changed from: {hi.data.from.location}, <Moment format="MMM Do YYYY">{hi.data.from.at}</Moment></div>}

              {hi.type === 'seminar_registration' && hi.data.event === 'attended' && <div>{hi.data.seminar_location}, <Moment format="MMM Do YYYY">{hi.data.seminar_at}</Moment></div>}

              {hi.data.note && <div>
                {hi.data.note.split('\n').map((item, key) => {
                  return <span key={key}>{item}<br/></span>
                })}
              </div>}
            </td>
          </tr>
        ))}
        </tbody>
      </Table>
      </div>
    )
  }
}